import { useRouter } from 'expo-router';
import React from 'react';
import { Platform, Pressable, Text, View } from 'react-native';

import AppStyles from '@/constants/Styles';

export default function ScanLink() {
  const router = useRouter();
  if (Platform.OS === 'web') return null;
  return (
    <View style={{ alignItems: 'flex-end', padding: 10 }}>
      <Pressable
        onPress={() => router.push('/scan')}
        style={({ pressed }) => [
          AppStyles.primaryButton,
          { maxWidth: 400, width: '100%', opacity: pressed ? 0.7 : 1 },
        ]}
      >
        <Text style={AppStyles.primaryButtonText}>Scan QR Code for Access</Text>
      </Pressable>
    </View>
  );
} 